import type { Theme } from './types'

export const minimalTheme: Theme = {
  name: 'minimal',
  colors: {
    // Minimal monochrome with single accent
    primary: '#000000',
    secondary: '#666666',
    
    // Pure minimal backgrounds
    background: '#ffffff',
    surface: '#ffffff',
    
    // High contrast text
    text: '#000000',
    textSecondary: '#666666',
    
    // Minimal border
    border: '#e0e0e0',
    
    // Minimal status colors
    success: '#000000',
    warning: '#666666',
    error: '#000000',
    
    // Minimal order status (using opacity/text for differentiation)
    statusDraft: '#cccccc',
    statusSubmitted: '#666666',
    statusConfirmed: '#000000',
    statusBilled: '#333333',
    statusCompleted: '#000000',
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.75rem',    // Slightly more generous
    md: '1.5rem',     // More white space
    lg: '2.5rem',     // Generous spacing
    xl: '4rem',       // Very generous
  },
  typography: {
    fontFamily: '"Inter", system-ui, -apple-system, sans-serif',
    fontSize: {
      sm: '0.8125rem',  // 13px - tighter
      md: '0.9375rem',  // 15px
      lg: '1.0625rem',  // 17px
      xl: '1.1875rem',  // 19px
    },
    fontWeight: {
      normal: 400,
      medium: 500,
      bold: 700,      // Bolder for contrast
    },
  },
  borderRadius: {
    sm: '0',        // No radius - sharp edges
    md: '0',        // No radius - sharp edges
    lg: '0.125rem', // Minimal radius only for large elements
  },
  shadows: {
    sm: 'none',     // No shadows
    md: 'none',     // No shadows
    lg: '0 1px 2px rgba(0, 0, 0, 0.1)', // Minimal shadow only for modals
  },
} 